import React, { Component } from 'react';
import {connect} from 'react-redux';

import Modal from 'react-responsive-modal';
import SearchResultsForm from './SearchResultsForm';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

import Logger, {LOG_LEVELS} from '../../utils/logger';


const log = new Logger('TRANSACTION_SEARCH_CONFIRM_ACTION', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
  modal: 'modal-full-width-height modal-max-width-85 pb0'
};

export class TransactionSearchConfirmAction extends Component {
  constructor(props) {
    super(props);
    this.state = {comment: ''};
  }
  onChange(fieldName, evt) {
    const newState = {};
    newState[fieldName] = evt.target.value;
    this.setState(newState);
  }
  render() {
    log.debug('render: ', this.props);

    return (
      <div>
        <Modal
          open={Array.isArray(this.props.list) && this.props.list.length > 0}
          onClose={this.props.onCancel}
          classNames={MODAL_CLASSNAMES}
        >
          <div>
            <h2><LanguageStringResolver string={this.props.title}/></h2>
            {
              this.props.action === 'export' ? (<span></span>) :
                (<fieldset>
                  <label className="mt10"><LanguageStringResolver string="transactionSearchActionConfirmationLabel_Username"/></label>
                  <input
                    type="text"
                    value={this.props.username}
                    disabled={true}
                  />
                  <label className="mt10"><LanguageStringResolver string="transactionSearchActionConfirmationLabel_Comment"/></label>
                  <textarea
                    onChange={this.onChange.bind(this, 'comment')}
                    value={this.state.comment}
                  />
                </fieldset>)}
            <button className='primary mt10' onClick={() => {this.props.onConfirmed(this.props.username, this.state.comment)}}>
              <LanguageStringResolver string="transactionSearchActionConfirmationButton_Confirm"/>
            </button>
            <button className='secondary mt10' onClick={this.props.onCancel}>
              <LanguageStringResolver string="transactionSearchActionConfirmationButton_Cancel"/>
            </button>
          </div>
          <div className="clear"></div>
          <div>
            <SearchResultsForm
              transactionPage = {this.props.list}
              allowActions={false}
              disableLinks={true}
            />
          </div>
        </Modal>

      </div>
    )
  }
}


TransactionSearchConfirmAction.defaultProps = {
};

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state, props);
  const username = props.username || (state.authentication && state.authentication.data && state.authentication.data.userName) || 'Unknown';
  return {
    username,
  };
}



// Wrap the component to inject state into it
export default connect(mapStateToProps)(TransactionSearchConfirmAction);
